export default __webpack_public_path__ + "static/body-v2-03-sleeve-3d8257585c34e745c8fc2345e3d9ad32.png";